/**
 * Uppercase the first letter in a string
 */
export const ucFirst = str =>
  str ? str.charAt(0).toUpperCase() + str.slice(1) : '';

/**
 * Uppercase the first letter of each word in a string
 */
export const ucFirstOfEachWord = str =>
  str
    ? str
        .split(' ')
        .map(word => ucFirst(word))
        .join(' ')
    : '';

export function formatPrice(price, showCents = true) {
  if (price == null) return null;
  let options = {
    style: 'currency',
    currency: 'USD'
  };
  if (!showCents) {
    options = {
      ...options,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    };
  }
  return new Intl.NumberFormat('us-US', options).format(price);
}

export function formatPhoneNumber(number) {
  var cleaned = ('' + number).replace(/\D/g, '');
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return null;
}

/**
 * Enables string substition for variable strings (eg coming from Content stack)
 * const greeting = fillTemplate('Hi ${firstName}', {firstName: 'Joe'});
 * >> 'Hi Joe'
 */
export function fillTemplate(templateString, templateVariables) {
  const keys = Object.keys(templateVariables);
  const values = Object.values(templateVariables);
  // eslint-disable-next-line
  let templateFunction = new Function(...keys, `return \`${templateString}\`;`);
  return templateFunction(...values);
}
